module.exports = __webpack_public_path__ + "static/media/anand-img-1.645c62b9.jpg";